export default "__VITE_ASSET__D9no7m$l__"